import MainHeader from "../modules/app/components/MainHeader";
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import styles from "./FerderateConnectionTestPage.modules.scss";
import classNames from "classnames";
import querystring from "query-string";
import { MainLoader } from "@netapp/bxp-design-system-react";
import { Card, Layout, Heading, Text } from "@netapp/bxp-design-system-react";
import { ErrorIcon, SuccessIcon } from "@netapp/bxp-style/react-icons/Notification"
import { appComponents as i18nNamespace} from "../i18n/namespace";
import { useTranslation } from "react-i18next";


export const RedirectToFederatedConnectionTest = (redirecturl) => {
    const search = querystring.parse(window.location.search);
    const paramsForLoginPage = { service: 'federated-connection-test'};
    const extra = paramsForLoginPage ? `?paramsForLoginPage=${window.btoa(JSON.stringify(paramsForLoginPage))}` : "";

    window.__testAppAuth.loginRedirect({
        responseType: 'token id_token',
        audience: "https://api.cloud.netapp.com",
        scope: 'openid profile',
        redirectUri: `${window.location.origin}/federated-connection-test${extra}`,
        testConnectionName: search.auth0Name
    }, undefined, {organizationId: search.organizationId, federationId: search.federationId});

    return <div><MainLoader/></div>;
};

const StatusCard = ({status, federations, error,t}) => (
    <Layout.Container>
        <Layout.Grid centerContent>
            <Layout.GridItem lg={6}>
                {status === "SUCCESS" && <Card style={{padding: 20, marginTop: 104}}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <SuccessIcon size={50} color='success' />
                        <Heading level={20} style={{ paddingLeft: 16 }} bold>{t("federation_setup_test_completed")}</Heading>
                    </div>
                    <Text style={{ marginTop: 16 }}>{t("test_completed")} {federations[0].name}</Text>
                    <Text>{t("close_tab")}</Text>
                </Card>}
                {status === "ERROR" && <Card style={{ padding: 20, marginTop: 104}}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <ErrorIcon size={50} color="error" />
                        <Heading level={20} style={{ paddingLeft: 16 }} bold>{t("oops_something_went_wrong")}</Heading>
                    </div>
                    <Text style={{ marginTop: 16 }}>{error?.error + " : " + error?.errorDescription}</Text>
                    <Text>{t("to_continue")}</Text>
                </Card>}
                {status === "PENDING" && <Card style={{padding: 40, height: 120, marginTop: 104}}>
                    <MainLoader />
                    <Heading level={20} style={{ textAlign: "center" }} bold>{t("testing_connection")}</Heading>
                </Card>}
            </Layout.GridItem>
        </Layout.Grid>
    </Layout.Container>
)



export const FederationTestPage = () => {
    const testStatus = useSelector(state => state.auth.testStatus);
    const error = useSelector(state => state.auth.testAuthError);
    const federations = useSelector(state => state.auth.testAuthFederation);
    const dispatch = useDispatch()
    const { t } = useTranslation(i18nNamespace);


    useEffect(() => {
        dispatch({ type: "AUTH:FEDERATION-SETUP-TEST-CONNECTION" });
    },[])

    return ( <div className={classNames(styles['federation-setup'], styles['federation-setup-test-success'])}>
            <MainHeader focusLastNav={() => {}}/>
            <StatusCard status={testStatus} error={error} federations={federations} t={t}/>
    </div>)
}
